var exports = {
  "k": "xa15a2ab7--beba20--container",
};

module.exports = exports;
